export const formatConfShortUrlId = (shortUrlId: string) => {
    return shortUrlId.replace(/(.{4})/g, '$1 ').trim();
};
